import { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const ModeContext = createContext();

export function ModeProvider({ children }) {
    // Mode: 'personal', 'everything', or 'clinic'
    // But 'clinic' mode also needs a clinic_id.
    // Let's simplify: activeClinicId.
    // If activeClinicId is 'personal', we are in Personal mode.
    // If activeClinicId is 'everything', we are in Everything mode.
    // If activeClinicId is a UUID, we are in Specific Clinic mode.

    // Persist selection
    const [activeMode, setActiveMode] = useState(() => {
        return localStorage.getItem('activeMode') || 'everything';
    });

    useEffect(() => {
        localStorage.setItem('activeMode', activeMode);
    }, [activeMode]);

    // Helper to get readable label
    const getModeLabel = (clinics) => {
        if (activeMode === 'personal') return 'Personal Mode';
        if (activeMode === 'everything') return 'Everything Mode';
        const clinic = clinics.find(c => c.id === activeMode);
        return clinic ? clinic.name : 'Unknown Clinic';
    };

    return (
        <ModeContext.Provider value={{ activeMode, setActiveMode, getModeLabel }}>
            {children}
        </ModeContext.Provider>
    );
}

ModeProvider.propTypes = {
    children: PropTypes.node
};

export function useMode() {
    return useContext(ModeContext);
}
